import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { V4HousesModalSelectComponent } from "@root/router/component/v4/houses-modal-select/houses-modal-select.component";
import { OptionService } from "@root/router/index/option.service";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalService } from "ng-zorro-antd/modal";

@Component({
  selector: "host-widget-house-card",
  templateUrl: "./house-card.component.html",
  styleUrls: ["./house-card.component.scss"],
})
export class WidgetHouseCardComponent implements OnInit {
  private _orderDetail;
  @Input()
  get orderDetail() {
    return this._orderDetail;
  }

  set orderDetail(value) {
    this._orderDetail = value;
    if (value) {
      this.tagIds = value.reservation_tag?.map((tag) => tag.id);
    }
  }
  @Output() onUpdate = new EventEmitter();

  get isConflictOrder() {
    return !!this.orderDetail?.conflict_label?.is_conflict;
  }

  get optionsOfResTag() {
    return this.optSrv.optionsOfReservationTag;
  }

  tagEditing = false;
  tagIds;

  constructor(
    private router: Router,
    private modal: NzModalService,
    private msg: NzMessageService,
    private orderSrv: OrderV2Service,
    private t: TranslateService,
    private optSrv: OptionService,
  ) {}

  ngOnInit() {}

  toHouse(title: string) {
    this.modal.closeAll();
    this.router.navigate(["/app/properties/properties"], { queryParams: { title } });
  }

  toHouseType(title: string) {
    this.modal.closeAll();
    this.router.navigate(["/app/properties/room-types"], { queryParams: { title } });
  }

  toSettingOptionPage() {
    this.router.navigate(["/app/settings/custom-options"], { queryParams: { anchor: "tags" } });
    // this.drawerRef.close();
  }

  onTagOpenChange(open) {
    console.log("open: ", open);
    if (!open) {
      this.requestSaveTags().subscribe((res) => {
        if (res.error_code === 0) {
          this.onUpdate.emit();
          this.tagEditing = false;
        }
      });
    }
  }

  private requestSaveTags() {
    const params = {
      reservation_code: this.orderDetail.code,
      operator_tag_ids: this.tagIds,
    };
    return this.orderSrv.updateReservationTags(params);
  }

  @WritePermissionGurd("reservation_list")
  onClickChangeHouse() {
    const title = this.t.t("order.change_to_house");
    const modal = this.modal.create({
      nzTitle: title,
      nzContent: V4HousesModalSelectComponent,
      nzFooter: null,
      nzWidth: "936px",
      nzComponentParams: {
        mode: "single",
        params: {
          reservation_code: this.orderDetail?.code,
          type: "change_house",
        },
      },
    });
    modal.afterClose.subscribe(({ data: rst }) => {
      if (rst) {
        const codes = [this.orderDetail.code];
        const houseId = rst?.[0]?.value;

        this.requestBatchChangeHouse(codes, houseId).subscribe((rst) => {
          this.msg.success(this.t.t("success.order.order_change_house"));
          this.onUpdate.emit();
          // this.refreshModal.emit(true);
          // this.calendarService.refresh();
        });
      }
    });
  }

  @WritePermissionGurd("reservation_list")
  onClickMoveToOrderbox() {
    this.requestMoveToOrderbox().subscribe((res) => {
      if (res.error_code === 0) {
        this.msg.success(this.t.t("success.order.order_already_in_orderbox"));
        this.onUpdate.emit();
        // this.calendarService.refresh();
        // this.calendarService.removeReservation(this.orderDetail.code);
      }
    });
    // const params = {
    //   reservation_code: this.orderDetail.code,
    // };
    // this.orderSrv.putReservationBox(params).subscribe((res) => {
    //   if (res.error_code === 0) {
    //     this.msg.success(this.t.t('success.order.order_already_in_orderbox'));
    //     this.onUpdate.emit();
    //   }
    // });
  }

  private requestBatchChangeHouse(codes, houseId) {
    const params = {
      reservation_codes: codes,
      house_id: houseId,
    };
    return this.orderSrv.batchChangeHouse(params);
  }

  private requestMoveToOrderbox() {
    const params = {
      reservation_code: this.orderDetail.code,
    };
    return this.orderSrv.putReservationBox(params);
  }
}
